import { Modal } from "antd";
import { useCallback } from "react";

type ConfirmDeleteAllOptions = {
  title: string;
  content?: React.ReactNode;
  onOk: () => Promise<void> | void;
};

export function useConfirmDeleteAll() {
  const confirmDeleteAll = useCallback(
    ({ title, content, onOk }: ConfirmDeleteAllOptions) => {
      Modal.confirm({
        title: title,
        content,
        okText: "Отвязать вce",
        cancelText: "Отмена",
        okButtonProps: {
          danger: true,
        },
        onOk,
      });
    },
    []
  );

  return confirmDeleteAll;
}
